import { useHistory, useRouteMatch } from 'react-router';

export default function useRoute<Params extends { [K in keyof Params]?: string }>() {
  const match = useRouteMatch<Params>();
  const history = useHistory();

  return { push: history.push, replace: history.replace, match };
}
